import { IAppActionSetSaveRequest, IUnifiedState } from "./interface";

/**
 * Stores the save request lifecycle in unified application state.
 *
 * @param state - Application state shared by all save controls.
 * @param action - Request status supplied by loadWrapper.
 * @returns Application state with the updated save request.
 */
export const app_setSaveRequest = (
  state: IUnifiedState,
  action: IAppActionSetSaveRequest,
): IUnifiedState => ({ ...state, saveRequest: action.saveRequest });
